import React, { useState } from 'react';
import { ConditionSelect } from './ConditionSelect';
import { ValuePreview } from './ValuePreview';
import { ContributeAndSignup } from './ContributeAndSignup';
import { ValueConfirmation } from './ValueConfirmation';
import { getQuestionsForCondition, getAnswersForQuestion } from '../reflect/reflectData';

export const ValueFirstFlow = ({ onBack }) => {
  const [step, setStep] = useState(0);
  const [condition, setCondition] = useState(null);
  const [userData, setUserData] = useState(null);

  // Get first question + answers for selected condition
  const questions = condition ? getQuestionsForCondition(condition) : [];
  const question = questions[0] || null;
  const answers = question ? getAnswersForQuestion(question.id) : [];

  const handleConditionSelect = (c) => {
    setCondition(c);
    setStep(1);
  };

  const handleComplete = (data) => {
    setUserData(data);
    setStep(3);
  };

  const steps = [
    <ConditionSelect key={0} onSelect={handleConditionSelect} />,

    question && (
      <ValuePreview key={1}
        condition={condition}
        question={question}
        answers={answers}
        onContribute={() => setStep(2)} />
    ),

    question && (
      <ContributeAndSignup key={2}
        question={question}
        condition={condition}
        onComplete={handleComplete} />
    ),

    userData && (
      <ValueConfirmation key={3}
        firstName={userData.firstName}
        condition={condition}
        onCompleteProfile={onBack}
        onDone={onBack} />
    )
  ];

  return steps[step] || steps[0];
};
